/**
 * @file index.tsx
 *
 * @fileoverview Renders the title of the job search.
 */
import React from 'react';
import { useRouter } from 'next/router';
import SEOSearchTitle from '~/jobiqo/components/Search/SeoSearchTitle';
import { useIntl } from 'react-intl';
import { SearchApiJobResult } from '~/jobiqo/types/types';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

/**
 * Checks if we need to apply a simple SEO title.
 *
 * @param string|null search
 *   Search GET parameter.
 * @param string|null page
 *   Page GET parameter.
 * @param boolean eanbled.
 *   If the feature is eanbled based on flag.
 *
 * @return boolean
 *   Returns true if the functionality is enabled, and we need to apply
 *   a simple title, otherwise false.
 */
const applySeoTitle = ({
  search,
  page,
  enabled,
}: {
  search: string | null;
  page: string | null;
  enabled: boolean;
}): boolean => {
  if (!enabled) {
    return false;
  }
  return !!search || !!page;
};

interface JobSearchTitleProps {
  /**
   * The list of jobs.
   */
  jobs: SearchApiJobResult;
}

export default function JobSearchTitle({ jobs }: JobSearchTitleProps) {
  const router = useRouter();
  const intl = useIntl();
  const { JOBS } = useFrontendConfig();

  const SplitViewTitle = (
    <SEOSearchTitle
      title={intl.formatMessage({
        id: 'job_search_title_type',
        defaultMessage: 'job',
      })}
      searchResult={jobs}
      showHeaderTag={false}
    />
  );

  return applySeoTitle({
    search: router.query.search as string | null,
    page: router.query.page as string | null,
    enabled: JOBS.JOBS_LISTING_SEO_TITLE,
  }) ? (
    <div>{SplitViewTitle}</div>
  ) : jobs.seoSearchContent?.headerImage ? (
    <h2>{SplitViewTitle}</h2>
  ) : (
    <h1>{SplitViewTitle}</h1>
  );
}
